(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["meme-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('.mm-home-reviews');
  roots.forEach((root) => {
    let track;
    let viewport;
    let scheduled = false;
    const measure = () => {
      scheduled = false;
      if (!track || !viewport || !viewport.clientWidth) return;
      const match = track.style.transform.match(/translate3d\(\s*([-\d.]+)px/);
      const shift = match ? Number(match[1]) : 0;
      const width = viewport.clientWidth;
      const cards = Array.from(track.querySelectorAll('.jdgm-carousel-item'));
      const visible = cards.filter((card) => {
        const left = card.offsetLeft + shift;
        return left + card.offsetWidth > 2 && left < width - 2;
      });
      const height = Math.ceil(Math.max(0, ...visible.map((card) => card.scrollHeight)) + 4);
      if (height > 4) root.style.setProperty('--mm-carousel-height', height + 'px');
    };
    const schedule = () => {
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(measure);
      }
    };
    const bind = () => {
      const nextTrack = root.querySelector('.jdgm-carousel__item-wrapper');
      const nextViewport = root.querySelector('.jdgm-carousel__item-container');
      if (!nextTrack || !nextViewport) return;
      if (track !== nextTrack) {
        track = nextTrack;
        viewport = nextViewport;
        new MutationObserver(schedule).observe(track, {attributes: true, attributeFilter: ['style', 'class']});
        track.addEventListener('transitionend', schedule);
      }
      schedule();
    };
    new MutationObserver(bind).observe(root, {childList: true, subtree: true});
    new ResizeObserver(schedule).observe(root);
    window.addEventListener('resize', schedule);
    if (document.fonts) document.fonts.ready.then(schedule);
    bind();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
